<template>
  <div class="col px-0 px-md-3">
    <main class="row w-100 m-0 main-row d-flex flex-nowrap"
          role="grid">
      <div class="col center d-flex align-items-center justify-content-center bg-GreyPoints">
        <div class="row justify-content-center w-100">
          <div id="phylactere"
               class="col-12 my-auto">
            <h1 class="text-center openSans-bold mb-4">Bienvenue</h1>
            <b-form @submit.stop.prevent="checkErrors"
                    class="row w-100 m-0">
              <b-form-group id="groupeIdentifiant"
                            class="group d-block mb-4"
                            :invalid-feedback="errorMessage"
                            :state="error.identifiant">
                <b-form-input id="identifiant"
                              name="identifiant"
                              placeholder="Identifiant"
                              v-model="identifiant"
                              :state="error.identifiant"></b-form-input>
              </b-form-group>
              <b-form-group id="groupeMotDePasse"
                            class="group d-block"
                            :invalid-feedback="errorMessage"
                            :state="error.motDePasse">
                <b-form-input id="motDePasse"
                              name="motDePasse"
                              placeholder="Mot de passe"
                              type="password"
                              v-model="motDePasse"
                              :state="error.motDePasse"></b-form-input>
              </b-form-group>
              <div class="col-12 d-flex px-0">
                <a href=""
                   class="text-dark ml-auto mb-5"><u>Mot de passe oublié ?</u></a>
              </div>
              <b-form-checkbox id="rememberMe"
                               v-model="rememberMe"
                               name="rememberMe"
                               class="col-6 d-flex align-items-end px-0"
                               value="1"
                               unchecked-value="0">
                Se souvenir de moi
              </b-form-checkbox>
              <div class="col-6 d-flex px-0">
                <b-button type="submit"
                          squared
                          variant="dark"
                          class="text-uppercase ml-auto">
                  Connexion
                </b-button>
              </div>
            </b-form>
            <b-alert :show="dismissCountDown"
                     dismissible
                     fade
                     variant="danger">
              <small>Erreur dans la saisie de votre <strong>identifiant</strong> et / ou de votre <strong>mot de passe</strong>. <br> Veuillez réessayer.</small>
            </b-alert>
          </div>
          <div class="col-12 navBlob flex-row">
            <div class="row mt-3">
              <router-link id="immoNav" class="col-6 border-right border-dark" :to="{ name: 'Home' }">
                <img
                class="w-100"
                src="../../assets/images/logo-tolusimmo.svg" alt="">
              </router-link>
              <router-link id="cgcNav" class="col-6" :to="{ name: 'Home' }">
                <img
                class="w-100"
                src="../../assets/images/logo-CGcourtage.svg" alt="">
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { NavbarPlugin, FormGroupPlugin, FormPlugin, FormInputPlugin, FormTextareaPlugin, FormCheckboxPlugin, InputGroupPlugin, ButtonPlugin, AlertPlugin } from 'bootstrap-vue'

Vue.use(NavbarPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(AlertPlugin)

export default {
  name: 'Compte',
  data () {
    return {
      dataApi: {},
      identifiant: null,
      motDePasse: null,
      rememberMe: null,
      error: {
        identifiant: null,
        motDePasse: null
      },
      dismissSecs: 5,
      dismissCountDown: 0,
      errorMessage: 'Ce champs est requis'
    }
  },
  methods: {
    checkErrors () {
      this.error.identifiant = (!!this.identifiant)
      this.error.motDePasse = (!!this.motDePasse)
      let stop = false
      Object.values(this.error).forEach((value) => {
        if (value === false) {
          stop = true
        }
      })
      if (stop) {
        setTimeout(() => {
          Object.keys(this.error).forEach((key) => {
            this.error[key] = null
          })
        }, 3000)
      } else {
        this.connect()
      }
    },
    async connect () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        login: this.identifiant,
        password: this.motDePasse
      }
      this.dataApi = new DataApi(options, false)
      this.dataApi.login()
        .then((res) => {
          this.dataApi = res
          this.dataApi.validateSession()
            .then((response) => {
              if (response) {
                Vue.prototype.$token = this.dataApi.apiToken
                Vue.prototype.$isLogged = true
                this.$router.push({ name: 'TableauDeBord' })
              } else {
                this.showAlert()
              }
            })
        })
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.error.identifiant = false
      this.error.motDePasse = false
      this.dismissCountDown = this.dismissSecs
      setTimeout(() => {
        Object.keys(this.error).forEach((key) => {
          this.error[key] = null
        })
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  padding: 0 !important;
}
.bg-GreyPoints {
  height: calc(100vh - 2.8rem);
}
#phylactere {
  padding: 4rem !important;
  border-radius: 2.8rem 2.8rem 0 2.8rem !important;
  border: 1px solid var(--dark);
  max-width: 38rem !important;
  max-height: 38rem !important;
}

.group {
  border: 1px solid var(--dark) !important;
  width: 100% !important;
  height: 5.8rem !important;
  ::v-deep .bv-no-focus-ring {
    height: 100% !important;
    input {
      height: 100% !important;
    }
  }
}

.center {
  max-width: 38rem !important;
  padding: 0 !important;
}

</style>
